module.exports = __webpack_public_path__ + "img/home-about-经典案例.57688bcb.png";